import { render, staticRenderFns } from "./addevent.html?vue&type=template&id=2355f7bb&scoped=true&"
import script from "./addevent.js?vue&type=script&lang=js&"
export * from "./addevent.js?vue&type=script&lang=js&"
import style0 from "./addevent.scss?vue&type=style&index=0&id=2355f7bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2355f7bb",
  null
  
)

export default component.exports